<template>
  <main>
    <PageIntro
      :heading="'Are You An Existing UZ Digital Account User?'"
      :body="'<p>As you have an existing UZ Digital Account and are logging in for the first time on the new platform, you will need to reset your password.</p><p>Please enter your email below and we\'ll send you an email link with instructions to set up your new password.</p>'" />
    <ForgotPasswordForm />
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import ForgotPasswordForm from '@/components/ForgotPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      ForgotPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>
